import React, {Component} from "react";
import {types, PropTypes} from "Subschema";
import {getSelection, setSelection} from 'react/lib/ReactInputSelection';
import CustomMaskedInput from "./CustomMaskedInput";


export default class CardExpiryDate extends Component {
    static propTypes = {
        "onChange": PropTypes.valueEvent,
        "formatter": PropTypes.string
    };
    static defaultProps = {
        "formatter": 'MM/YY'
    };

    constructor(props, ...rest) {
        super(props, ...rest);
    }

    onChange = (e) =>{
        const inputVal = e.target.value;
        const expVal = inputVal.replace(/_/g, ' ');
        this.props.onChange(expVal);
    }

    render() {
        const {
            className,
            value,
            onChange,
            onKeyDown,
            ...props} = this.props;

        return (
            <span className={className}>
                <CustomMaskedInput {...props}
                    placeholderChar='_'
                    mask={this.props.formatter}
                    onChange={this.onChange}/>
                <i className={`${this.props.error ? this.props.hasErrorClass : ''}`}/>
            </span>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/types/card/CardExpiryDate.jsx
 **/